import React from "react";
import { Route, withRouter } from "react-router-dom";
import routes from "./../../config/page-route.jsx";
import { PageSettings, pageTitle as confPageTitle } from "./../../config/page-settings.js";

function setTitle (path, routeArray) {
  let pageTitle;
  for (let i = 0; i < routeArray.length; i++) {
    if (routeArray[i].path === path) {
      pageTitle = `${confPageTitle}的工作小站 | ` + routeArray[i].title;
    }
  }
  document.title = (pageTitle) || `${confPageTitle}的工作小站 | ${confPageTitle}`;
}

class Content extends React.Component {
  componentDidMount () {
    setTitle(this.props.history.location.pathname, routes);
  }

  componentWillMount () {
    this.props.history.listen(() => {
      setTitle(this.props.history.location.pathname, routes);
    });
  }

  render () {
    return (
      <PageSettings.Consumer>
        {({ pageContentFullWidth, pageContentClass }) => (
          <div className={"content " + (pageContentFullWidth ? "content-full-width " : "" + pageContentClass)}>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            ))}
          </div>
        )
        }
      </PageSettings.Consumer>
    );
  }
}

export default withRouter(Content);
